/* @flow */

import DebtorCompany from 'models/companies/debtorCompany';

export default class InvoiceStatus {
  debtorCompany: DebtorCompany;
  lastStep: number;
  isXmlFlow: boolean;
}
